import React, {FC, ReactNode, useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import {ButtonBox,  LayoutFooter, LayoutHeader, LoadingBox, PosUserPermissionLogin} from "../../..";
import {useCulture, useSidebar} from "../../../../hooks";
import {
    getDefaultLanguage,
    getLabelName,
    getUserId,
    getUserName,
    getUserStationId,
    isUserAuthenticated,
    secureLocalStorageClearLookupCache,
} from "../../../../utils";
import {ActionTypeEnum, PosUserPermissionActionTypeEnum, RequestActionModel,} from "../../../../models";
import {SystemConfiguration} from "../../../../configuration";
import {LangSwitcherReactI18} from "../../../languageSwitcher/react-i18/langSwitcher";
import face1 from "../../../../assets/images/faces/face1.jpg";
import {logoutUser} from "../../../../slice/userAuthincateSlice";
import {getPointOfSaleSetting, logoutServerUser} from "../../../../serviceBroker/userApiServiceBroker";


export const DefaultLayout: FC<{ children?: ReactNode | undefined }> = ({
  children,
}) => {
    //#region state
    const {changeCulture} = useCulture("");
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showCloseDayModel, setShowCloseDayModel] = useState(false);
    const [showPermissionLogin, setShowPermissionLogin] = useState(false);
    const {isOpen, setIsOpen} = useSidebar();
    const userId = useMemo(() => getUserId?.() ?? 0, []);
    const userName = useMemo(() => getUserName?.() ?? "", []);
    const stationId = useMemo(() => getUserStationId?.() ?? 0, []);
    const location = useLocation(); // detects URL changes
    //#endregion
    //#region variables
    const language: string = getDefaultLanguage();
    //#endregion
    //#region use-Effect
    useEffect(() => {
        document.body.classList.toggle("sidebar-close", isOpen);
    }, [isOpen]);
    useEffect(() => {
        if (window.innerWidth <= 992) {
            setIsOpen(false); // close sidebar when URL changes on mobile
        }
    }, [location.pathname]);
    useEffect(() => {
        const updateCulture = async () => {
            setLoading(true);
            await changeCulture(language);
            setLoading(false);
        };
        updateCulture().then(() => {
        });
        //changeCulture(language).then(() => {});
    }, [language]);
    //#endregion
    //#region functions
    const handleLogout = async (userId: number) => {
        const data = await logoutServerUser(userId);
        if (data?.Errors?.length ?? !data?.Result) {
            console.log(data?.Errors);
        } else {
            dispatch(
                // @ts-ignore
                logoutUser(userId)
            );
            navigate(SystemConfiguration.others_Configurations.logoutRedirectUrl);
        }
    };
    const handleAction = async (request: RequestActionModel) => {
        switch (request.action) {
            case ActionTypeEnum.CloseModelPopup:
                setShowCloseDayModel(false);
                break;
            case  ActionTypeEnum.GetUserPOSPermission:
                setShowPermissionLogin(false);
                setShowCloseDayModel(true);
                break;
            case  ActionTypeEnum.Generic:
                setShowPermissionLogin(false);
                break;
        }
    };
    const handleOpenCloseDayFlow = useCallback(async () => {
        setLoading(true)
        const posSetting = await getPointOfSaleSetting(userId, true);
        setShowCloseDayModel(posSetting.EnableCloseDay)
        setShowPermissionLogin(!posSetting.EnableCloseDay)
        setLoading(false)
    }, [userId]);
    //#endregion
    //#region html
    return (
        <div className="container-scroller">
            {loading && <LoadingBox />}
            <div className="container-fluid page-body-wrapper">
                <LayoutHeader />
                <div className="main-panel">
                    {isUserAuthenticated() && (
                        <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 d-flex flex-row">
                            <div className="navbar-menu-wrapper d-flex align-items-stretch">
                                <ButtonBox
                                    variant=""
                                    className="navbar-toggler navbar-toggler-right align-self-center"
                                    type="button"
                                    data-toggle="minimize"
                                    onClick={() => {
                                        setIsOpen(!isOpen);
                                    }}
                                >
                                    <span className="mdi mdi-menu"></span>
                                </ButtonBox>
                                <ul className="navbar-nav navbar-nav-right">
                                    <li className="nav-item nav-profile dropdown">
                                        <a
                                            className="nav-link dropdown-toggle"
                                            id="profileDropdown"
                                            href="#"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <div className="nav-profile-img">
                                                <img src={face1} alt="image" />
                                                <span className="availability-status online"></span>
                                            </div>
                                            <div className="nav-profile-text">
                                                <p className="mb-1 text-black">{userName}</p>
                                            </div>
                                        </a>
                                        <div
                                            className="dropdown-menu navbar-dropdown"
                                            aria-labelledby="profileDropdown"
                                        >
                                            <div
                                                className="dropdown-item"
                                                onClick={async () => {
                                                    setLoading(true);
                                                    await secureLocalStorageClearLookupCache();
                                                    setLoading(false);
                                                }}
                                            >
                                                <i className="mdi me-2 text-primary"></i>
                                                {getLabelName("cache Refresh")}
                                            </div>
                                            <div
                                                className="dropdown-item"
                                                onClick={async () => {
                                                    await handleOpenCloseDayFlow();
                                                }}
                                            >
                                                <i className="mdi mdi-logout me-2 text-primary"></i>
                                                {getLabelName("Close Day")}
                                            </div>
                                            <div
                                                className="dropdown-item"
                                                onClick={async () => {
                                                    await handleLogout(userId);
                                                }}
                                            >
                                                <i className="mdi mdi-logout me-2 text-primary"></i>
                                                {getLabelName("logout")}
                                            </div>
                                        </div>
                                    </li>
                                    <li className="nav-item">
                                        <LangSwitcherReactI18 />
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    )}
                    <div className="content-wrapper">{children}</div>
                    <LayoutFooter />
                </div>
            </div>
            {/*{showCloseDayModel && (*/}
            {/*    <CloseDayDetails*/}
            {/*        userId={userId}*/}
            {/*        stationId={stationId}*/}
            {/*        onActionEvent={async (o: RequestActionModel) => {*/}
            {/*            await handleAction(o);*/}
            {/*        }}*/}
            {/*    />*/}
            {/*)}*/}
            {showPermissionLogin && (
                <PosUserPermissionLogin
                    userPermissionType={PosUserPermissionActionTypeEnum.CloseDay}
                    onActionEvent={handleAction}
                />
            )}
        </div>
    );
    //#endregion
};
